module.exports = __webpack_public_path__ + "img/stretch--arrow_right.cc8ab74f.png";